import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { reveal } from "@/components/shared/motion";

export const BriefSuccess = ({ onReset }) => (
  <motion.div
    data-testid="brief-success"
    variants={reveal}
    initial="hidden"
    animate="show"
    className="rounded-3xl border border-[#06B6D4]/25 bg-[#12141C]/60 p-10 backdrop-blur-2xl md:p-16"
  >
    <span className="flex h-12 w-12 items-center justify-center rounded-full border border-[#06B6D4]/50 bg-[#06B6D4]/10">
      <Check className="h-5 w-5 text-[#06B6D4]" />
    </span>
    <h2 className="font-display mt-8 text-3xl font-black uppercase tracking-tight text-[#F4F6FB] md:text-5xl">
      Transmission received.
    </h2>
    <p className="mt-5 max-w-md text-sm leading-relaxed text-[#F4F6FB]/60 md:text-base">
      We'll review your brief and get back to you. A confirmation is already on its way to your
      inbox.
    </p>
    <button
      type="button"
      data-testid="brief-reset-button"
      onClick={onReset}
      className="mt-10 font-mono text-[11px] uppercase tracking-[0.25em] text-[#06B6D4] transition-colors duration-300 hover:text-[#F4F6FB]"
    >
      Send another brief →
    </button>
  </motion.div>
);

export default BriefSuccess;
